/* @generated from adl module ferovinum.app.dealextensionrequests */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_dtos from './dtos';

/**
 * Represents a deal leg stage (CSD stage or FSD stage) that is expiring or has already expired
 */
export interface ExpiringDealLeg {
  /**
   * At least one of these 2 fields will be present
   * Note: There could be a rare case where both are present,
   * if for some reason both CSD and FSD dates are close enough, or the CSD units have expired
   * long time ago and they haven't been repurchased or renewed yet
   * A [null] value indicates that the stage is not expiring or expired
   * Compulsory Sale Date stage expiry date
   */
  CSDStage: (common.LocalDate|null);
  /**
   * Final Sale Date stage expiry date
   */
  FSDStage: (common.LocalDate|null);
  product: ferovinum_app_dtos.ProductDTOWithId;
  deal: common_db.WithDbId<ferovinum_app_db.Deal>;
  dealLeg: common_db.WithDbId<ferovinum_app_db.DealLeg>;
  /**
   * Total quantity expiring or expired
   */
  quantity: ferovinum_app_db.NumberOfUnits;
  pricePerUnit: common.BigDecimal;
  capexPerUnit: common.BigDecimal;
  depositPerUnit: common.BigDecimal;
}

export function makeExpiringDealLeg(
  input: {
    CSDStage: (common.LocalDate|null),
    FSDStage: (common.LocalDate|null),
    product: ferovinum_app_dtos.ProductDTOWithId,
    deal: common_db.WithDbId<ferovinum_app_db.Deal>,
    dealLeg: common_db.WithDbId<ferovinum_app_db.DealLeg>,
    quantity: ferovinum_app_db.NumberOfUnits,
    pricePerUnit: common.BigDecimal,
    capexPerUnit: common.BigDecimal,
    depositPerUnit: common.BigDecimal,
  }
): ExpiringDealLeg {
  return {
    CSDStage: input.CSDStage,
    FSDStage: input.FSDStage,
    product: input.product,
    deal: input.deal,
    dealLeg: input.dealLeg,
    quantity: input.quantity,
    pricePerUnit: input.pricePerUnit,
    capexPerUnit: input.capexPerUnit,
    depositPerUnit: input.depositPerUnit,
  };
}

const ExpiringDealLeg_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dealextensionrequests","decl":{"annotations":[{"value":"Represents a deal leg stage (CSD stage or FSD stage) that is expiring or has already expired\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"At least one of these 2 fields will be present\nNote: There could be a rare case where both are present,\nif for some reason both CSD and FSD dates are close enough, or the CSD units have expired\nlong time ago and they haven't been repurchased or renewed yet\nA [null] value indicates that the stage is not expiring or expired\nCompulsory Sale Date stage expiry date\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"CSDStage","default":{"kind":"nothing"},"name":"CSDStage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"value":"Final Sale Date stage expiry date\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"FSDStage","default":{"kind":"nothing"},"name":"FSDStage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"ProductDTOWithId"}},"parameters":[]}},{"annotations":[],"serializedName":"deal","default":{"kind":"nothing"},"name":"deal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Deal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"dealLeg","default":{"kind":"nothing"},"name":"dealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLeg"}},"parameters":[]}]}},{"annotations":[{"value":"Total quantity expiring or expired\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"pricePerUnit","default":{"kind":"nothing"},"name":"pricePerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capexPerUnit","default":{"kind":"nothing"},"name":"capexPerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"depositPerUnit","default":{"kind":"nothing"},"name":"depositPerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"ExpiringDealLeg","version":{"kind":"nothing"}}};

export const snExpiringDealLeg: ADL.ScopedName = {moduleName:"ferovinum.app.dealextensionrequests", name:"ExpiringDealLeg"};

export function texprExpiringDealLeg(): ADL.ATypeExpr<ExpiringDealLeg> {
  return {value : {typeRef : {kind: "reference", value : snExpiringDealLeg}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.dealextensionrequests.ExpiringDealLeg" : ExpiringDealLeg_AST
};
